import React from "react";
import styles from "./SegmentUpdateCompleted.module.scss";
import DoneImage from "../../../Components/assets/Images/congratsdoneimage.svg";

function SegmentUpdationApproved() {
  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>Request has been approved</p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                Modification request has been approved successfully. You will
                receive a confirmation email.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SegmentUpdationApproved;
